import { render, staticRenderFns } from "./invoiceDetial.vue?vue&type=template&id=1c4861c4&scoped=true&"
import script from "./invoiceDetial.vue?vue&type=script&lang=js&"
export * from "./invoiceDetial.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetial.vue?vue&type=style&index=0&id=1c4861c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4861c4",
  null
  
)

export default component.exports